import * as types from './mutation-types';
import { routeHasExist } from '@/utils/route';

const mutations = {
	[types.SET_TAGS](state, payload) {
		state.tags = payload.tags;
		localStorage.setItem('tags', JSON.stringify(state.tags));
	},
	[types.ADD_TAG](state, payload) {
		let route = payload.route;
		if (!routeHasExist(state.tags, route)) {
			if (route.name === 'home') {
				state.tags.unshift(route);
			} else {
				state.tags.push(route);
			}
			// 保存在localStorage
			localStorage.setItem('tags', JSON.stringify(state.tags));
		}
	},
	[types.REMOVE_TAG](state, payload) {
		let index = payload.index;
		state.tags.splice(index, 1);
		// 保存在localStorage
		localStorage.setItem('tags', JSON.stringify(state.tags));
	},
	[types.SET_TAG](state, payload) {
		state.tag = payload.tag;
		// 保存在localStorage
		localStorage.setItem('tag', JSON.stringify(state.tag));
	},
	[types.SELECT_LANGS](state, payload) {
		state.lang = payload.lang;
		// 保存在localStorage
		localStorage.setItem('lang', state.lang);
	},
	[types.ADD_DOWNLOAD](state, payload) {
		state.downloads = [].concat(payload);
	},
	[types.GET_DOWNLOADS](state) {
		console.log(state);
	},
	[types.REMOVE_DOWNLOAD](state, payload) {
		state.downloads.splice(payload, 1);
	},
	[types.REMOVE_DOWNLOADS](state) {
		state.downloads = [];
	},
	[types.CHANGE_DOWNLOAD_STATE](state, payload) {
		state.isDownloaded = payload;
	},
	[types.SAVE_ERROR_LOG](state, payload) {
		// console.log(state, payload);
		state.errors.unshift(payload);
		// console.log('payload', payload);
		// console.log(state.errors, payload);
		sessionStorage.setItem('errors', JSON.stringify(state.errors));
	},
	[types.GET_QUERY](state, payload) {
		state.query = payload;
	},
	[types.UPDATE_AREA](state) {
		console.log(state);
		localStorage.setItem('UPDATE_AREA', Date.now().toString());
	}
};

export default mutations;
